import React from "react";
import PropTypes from "prop-types";
import Typography from "../../common-components/Typography";
import { font } from "../../constants/font";
import { STATIC_PATH } from "../../constants/config";
import { formatPriceByLocale, PLAN } from "../../constants";
import {
  Image,
  Wrapper,
} from "../upgrade/upgrade-components";
import {
  Line,
  PlanCardHead,
  PriceContainer,
  SubTextContainer,
  UpgradCard,
} from "./payment-component";
import RadioButton from "../../common-components/RadioButton";

const PlanCard = ({
  iconSrc,
  planName,
  titleSubtext,
  width,
  height,
  onClick,
  data,
  monthlyPrice,
  yearlyPrice,
  className,
  active,
  padding,
  cycleData,
  countryCode,
  isDisabled
}) => {
  const isTeamPlan = data.plan === PLAN.TEAM;

  return (
    <UpgradCard
      width={width}
      height={height}
      enterprise={data.plan === PLAN.ENTERPRISE}
      isPremium={isTeamPlan}
      onClick={onClick}
      className={className}
      active={active && !isDisabled}
      padding={padding}
      isDisabled={isDisabled}
    >
      <Wrapper>
        <PlanCardHead>
          <Image
            style={{ paddingTop: "1px" }}
            src={`${STATIC_PATH}${iconSrc}`}
          />
          <PriceContainer>
            <Typography
              content={planName}
              font={font.bold_16}
              color={"#313345"}
              padding={"3px 0px"}
              cursor={"pointer"}
              enableTrim={false}
            />
            <Typography
              content={data.plan === PLAN.ENTERPRISE ? "Switch to our Enterprise Plan!" : `${countryCode === "IN" ? "₹" : "$"}${formatPriceByLocale(monthlyPrice) || formatPriceByLocale(yearlyPrice)}/month`}
              font={font.normalBase_medium_16}
              padding="3px 0"
              color={"#0D0F0F"}
              cursor={"pointer"}
              enableTrim={false}
            />
          </PriceContainer>
        </PlanCardHead>

        <Line />
        <SubTextContainer>
          <Typography
            content={titleSubtext}
            font={font.normalBase_16}
            color={"#4A4F66"}
            padding={"17px 0px 0px 0px"}
            cursor={"pointer"}
            enableTrim={false}
            beforeIcon={`${STATIC_PATH}green-tick.svg`}
          />
          <Typography
            content={cycleData}
            font={font.normalBase_medium_16}
            color={"#4A4F66"}
            padding={"17px 0px 0px 0px"}
            cursor={"pointer"}
            enableTrim={false}
          />
        </SubTextContainer>
      </Wrapper>
      <RadioButton isChecked={active && !isDisabled} />
    </UpgradCard>
  );
};

PlanCard.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  iconSrc: PropTypes.string,
  titleSubtext: PropTypes.string,
  planName: PropTypes.string,
  onClick: PropTypes.func,
  data: PropTypes.object,
  monthlyPrice: PropTypes.number,
  yearlyPrice: PropTypes.number,
  className: PropTypes.string,
  active: PropTypes.bool,
  padding: PropTypes.string,
  cycleData: PropTypes.string,
  countryCode: PropTypes.string,
  isDisabled: PropTypes.bool,
};
export default PlanCard;
